
export default class Sheet {
	constructor(sheet) {
		this.sheet = sheet;
		this.image = sheet.image;
		this.width = sheet.width;
		this.height = sheet.height;
		this.sprites = null;
	}

	init() {
		let w = this.image.width;
		let h = this.image.height;

		this.canvas = jQuery("<canvas width='" + w + "px' height='" + h + "px'></canvas>");
		jQuery("body").append(this.canvas);
		this.ctx = this.canvas.get(0).getContext("2d");
		this.ctx.drawImage(this.image, 0, 0);

		this.sprites = new Array();
		let rows = Math.floor(h / this.height);
		let cols = Math.floor(w / this.width);
		for (let row = 0; row < rows; row++) {
			this.sprites.push(new Array())
			for (let col = 0; col < cols; col++) {
				let imageUrl = this.crop(row, col);
				this.sprites[this.sprites.length - 1].push(imageUrl);
			}
		}
		this.canvas.remove();
	}

	crop(row, col) {
		let tileWidth = this.width;
		let tileHeight = this.height;
		let img = this.ctx.getImageData(col * tileWidth, row * tileHeight, tileWidth, tileHeight);
		//
		let canvas = jQuery("<canvas width='" + tileWidth + "px' height='" + tileHeight + "px'></canvas>");
		jQuery("body").append(canvas);
		let ctx = canvas.get(0).getContext("2d");
		ctx.putImageData(img, 0, 0);
		let ret = canvas.get(0).toDataURL();
		canvas.remove();
		return ret;
	}



}